import { Cookies } from 'react-cookie';
import { CookieSetOptions } from 'universal-cookie';

const cookies = new Cookies();

export const cookieStorage = {
  setCookie: (key: string, value: string, options?: CookieSetOptions) => {
    return cookies.set(key, value, {
      path: '/',
      secure: import.meta.env.VITE_BUILD_MODE === 'prod' ? true : false,
      sameSite: 'lax',
      ...options
    });
  },

  getCookie: (key: string) => {
    return cookies.get(key);
  },

  removeCookie: (key: string) => {
    return cookies.remove(key, { path: '/' });
  },

  clearAllCookies: () => {
    const keys = cookies.getAll();

    return Object.keys(keys).forEach((key) => {
      cookies.remove(key, { path: '/' });
    });
  }
};

const COOKIE_BASE_NAME = 'fadhili';

export const COOKIE_ACCESS_TOKEN = `${COOKIE_BASE_NAME}_acst` as const;
export const COOKIE_REFRESH_TOKEN = `${COOKIE_BASE_NAME}_rfst` as const;
export const COOKIE_SAVE_USER_ID = `${COOKIE_BASE_NAME}_suid` as const;
export const COOKIE_MOBILE = `${COOKIE_BASE_NAME}_mobile` as const;
export const COOKIE_NATAION_ID = `${COOKIE_BASE_NAME}_nationId` as const;
export const COOKIE_USER_FILE_ID = `${COOKIE_BASE_NAME}_userFileId` as const;
export const STORAGE_LOCAL_COLLAPSED = `${COOKIE_BASE_NAME}_collapsed` as const;
export const STORAGE_LOCAL_MENU_COLLAPSED = `${COOKIE_BASE_NAME}_menu_collapsed` as const;

export const COOKIE_PKG = `${COOKIE_BASE_NAME}_pkg` as const;
export const COOKIE_PKG_ID = `${COOKIE_BASE_NAME}_pkg_id` as const;
